import { checkWebView } from "@func";

export function getPathWithToken(qs: string): string {
  const isWebView = checkWebView();

  if (isWebView) {
    const params = new URLSearchParams(window.location.search);
    const accessToken = params.get("access_token");
    const apiAccessToken = params.get("api-access-token");

    const accessTokenQuery = `?access_token=${accessToken}`;
    // 3.0 토큰이 존재할 경우 2.0, 3.0 두 토큰 모두 쿼리에 붙힌다.
    const combineTokenQuery = apiAccessToken
      ? `${accessTokenQuery}&api-access-token=${apiAccessToken}`
      : accessTokenQuery;

    const nextQs = `${combineTokenQuery}${qs !== "" ? `&${qs}` : ""}`;

    return `${window.location.pathname}${nextQs}`;
  }

  return `/${qs}`;
}
